import {
  OrganizationAddress,
  OrganizationBaseFragment,
  OrganizationContactPoint,
  Practitioner,
} from '~/graphql/generated/graphql';
import { getWorkFax, getWorkPhone } from '~/utils/contact_points';
import { isYakumaruCustomSettingActive } from '~/utils/yakumaru_organization_setting';

export const formatOrganizationBase = (loginPractitioner: Practitioner) => {
  const organization = loginPractitioner.organization as OrganizationBaseFragment;
  const contactPoints = organization.organizationContactPoints
    ? (organization.organizationContactPoints as OrganizationContactPoint[])
    : [];
  const address =
    organization.organizationAddresses.length > 0
      ? (organization.organizationAddresses[0] as OrganizationAddress)
      : null;

  return {
    id: organization.id,
    name: organization.name,
    slug: organization.slug,
    pharmacyCode: organization.pharmacyCode || null,
    yakumaruCustomSettingActive: isYakumaruCustomSettingActive(
      organization.yakumaruOrganizationSetting,
    ),
    address: {
      id: address ? address.id : null,
      position: address ? address.position : null,
      city: address ? address.address.city : null,
      line: address ? address.address.line : null,
      postalCode: address ? address.address.postalCode : null,
      prefecture: address ? address.address.prefecture : null,
      latitude: address?.address.latitude || undefined,
      longitude: address?.address.longitude || undefined,
    },
    tel: getWorkPhone(contactPoints),
    fax: getWorkFax(contactPoints),
  };
};
